import { render } from "./DoctorTimeslotsForm.vue?vue&type=template&id=4867bb5d&scoped=true"
import script from "./DoctorTimeslotsForm.vue?vue&type=script&lang=js"
export * from "./DoctorTimeslotsForm.vue?vue&type=script&lang=js"

import "./DoctorTimeslotsForm.vue?vue&type=style&index=0&id=4867bb5d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4867bb5d"]])

export default __exports__